// Who-am-I data layer. Cookie-authed (credentials: 'include').
export interface Me { userId: string; email: string | null; isAdmin: boolean; teams: Array<{ id: string; name: string; role: string }>; }
export type MeResult = { ok: true; me: Me } | { ok: false; unauthenticated?: boolean };

export async function fetchMe(apiBase = '', fetchImpl: typeof fetch = fetch): Promise<MeResult> {
  try {
    const res = await fetchImpl(`${apiBase}/api/me`, { credentials: 'include' });
    if (res.status === 401) return { ok: false, unauthenticated: true };
    if (!res.ok) return { ok: false };
    return { ok: true, me: await res.json() as Me };
  } catch { return { ok: false }; }
}
